import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import React from "react";

import logo_damine from '../images/logo_damine.png'
import { confirmDialog } from "primereact/confirmdialog";

export type types = 'info' | 'warn' | 'success' | 'error'

export const message = (toast: Toast | null, message = 'Módulo em desenvolvimento', type: types = 'info') => {
    if (toast !== null) {
        console.log(message)
        toast.clear();
        setTimeout(() => {
            toast.show({
                severity: type,
                summary: message,
                sticky: true,
                content: (props: any) => (
                    <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                        <div className="flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar image={logo_damine} shape="circle" />
                            <span className="font-bold text-900" style={{ paddingInlineStart: 5 }}><b>GEARSPARK</b></span>
                        </div>
                        <br></br>
                        <div className="font-medium text-lg my-3 text-900">{props.message.summary}</div>
                        <br></br>
                        <Button className="p-button-sm flex" label="Ok" severity='info' onClick={() => clear(toast)}></Button>
                    </div>
                )
            });
        }, 400);
    }
}

export const errorMessage = (toast: Toast | null, m = 'Erro de conexão com servidor!') => {
    setTimeout(() => message(toast, m, 'error'), 400)
};

export const clear = (toast: Toast) => {
    toast.clear();
};

export function littleMessage(msgs: any, mensagem = 'Módulo em desenvolvimento!', type: types = 'info') {
    if (msgs)
        msgs.show([{
            stick: true,
            severity: type,
            content: (
                <React.Fragment>
                    <Avatar image={logo_damine} shape="circle" />
                    <div className="ml-2" style={{ paddingInlineStart: 10 }}>{mensagem}</div>
                </React.Fragment>
            ),
        }])
}

export const confirmacao = (toast: Toast | null, message = 'Módulo em desenvolvimento', type: types = 'info', sim: Function) => {
    if (toast !== null) {
        // var waiting = false
        toast.clear();
        const currentToastElement = toast.getElement();
        const delay = (currentToastElement && currentToastElement.children[0] && currentToastElement.children[0].childElementCount) ? 400 : 0;
        setTimeout(() => {
            const toastElement = toast.getElement();
            if (toastElement && toastElement.children[0] && toastElement.children[0].childElementCount) {
                return;
            }
            toast.show({
                severity: type,
                summary: message,
                sticky: true,
                content: (props: any) => (
                    <div className="flex flex-column align-items-left" style={{ flex: '1' }}>
                        <div className="flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center' }}>
                            <Avatar image={logo_damine} shape="circle" />
                            <span className="font-bold text-900" style={{ paddingInlineStart: 5 }}><b>GEARSPARK</b></span>
                        </div>
                        <br></br>
                        <div className="font-medium text-lg my-3 text-900">{props.message.summary}</div>
                        <br></br>
                        <Button className="p-button-sm flex" label={/*waiting ? '' : */'Sim'} severity='success' onClick={() => { clear(toast); sim(); /*waiting = true;*/ }}>{/*waiting && <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />*/}</Button>
                        <Button className="p-button-sm flex" label="Não" severity='danger' onClick={() => clear(toast)}></Button>
                    </div>
                )
            })
        }, delay)
    }
}

// const confirmBefore = (toast: Toast, confirmMessage: string, action: Function, sucessMessage: string, ) => {
//         const mensagemSucesso = () => {
//             message(toast, sucessMessage)
//         }
//         confirmacao(toast, "Confirma o reset de senha de " + pessoa.nome_razao + '?', 'warn', () => { resetarSenha(pessoa, mensagemSucesso) })
// }

export const createOtherCultivo = (id: any, accept: Function, reject: Function) => {
    confirmDialog({
        message: 'Cultivo cadastrado com sucesso de id ' + id + '!\nDeseja adicionar outro cultivo?',
        header: 'Cadastro de Cultivo',
        icon: 'pi pi-exclamation-triangle',
        // defaultFocus: 'accept',
        // accept(),
        // reject()
    });
};

/*type errorProps = {
    visible?: boolean,
    setVisible?: Function,
    title?: string,
    message?: string
}
export default function ErrorDialog(props: errorProps){
    const [selfVisible, selfSetVisible] = useState(true)
    const setVisible = (vis: boolean)=>{
        if (props.setVisible){
            props.setVisible(vis)
        } else {
            selfSetVisible(vis)
        }
    }
    const headerElement = (
        <div className="inline-flex align-items-center justify-content-center gap-2">
            <span className="font-bold white-space-nowrap">{props.title||'ERRO'}</span>
        </div>
    );
    const footerContent = (
        <div>
            <Button label="Ok" icon="pi pi-check" onClick={() => setVisible(false)} autoFocus />
        </div>
    );
    return (
        <Dialog visible={props.visible!==undefined ? props.visible : selfVisible} modal header={headerElement} footer={footerContent} style={{ width: '50rem' }} onHide={() => {setVisible(false)}}>
            <p className="m-0">
                {props.message||'Erro'}
            </p>
        </Dialog>
    )
} */